import { render, staticRenderFns } from "./FilterRooms.vue?vue&type=template&id=256ebc2e"
import script from "./FilterRooms.vue?vue&type=script&lang=js"
export * from "./FilterRooms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/vercel/path0/components/common/Button.vue').default,Input: require('/vercel/path0/components/common/Input.vue').default,Label: require('/vercel/path0/components/common/Label.vue').default,Card: require('/vercel/path0/components/common/Card.vue').default})
